<template>
  <div>
    <vue-headful title="Vacature" />
    <Header page_title="Vacature" />
    <div v-if="job" id="profile" class="job-layout sd-job">
      <div v-if="this.$store.state.notification.notifications.length > 0" class="container-fluid">
        <NotificationContainer />
      </div>
      <div class="job-header container-fluid">
        <div class="avatar rounded-circle position-relative overflow-hidden" >
          <span
            v-if="job.company_avatar"
            class="d-block image_background"
            :style="this.ImageBackground(job.company_avatar)"
          ></span>
          <span v-else class="avatar-icon">
            <svg-icon icon="education" />
          </span>
        </div>
        <div class="spec-container" v-if="subBranch === '2' || (subBranch === '1' && job.duration_type == 1)">
          <div><b>Gewenste startdatum: {{ dateFlip(firstDate()) }}</b><span v-if="subBranch === '1' && job.duration_type == 1" class="duration_type recent_yellow">Langdurig</span></div>
          <div><b>Verwachte einddatum: {{ dateFlip(lastDate())}}</b></div>
        </div>
        <div class="spec-container" v-else>
          <div><b>Start: {{ dateFlip(firstDate()) }}</b><span class="duration_type recent">{{totalDates}} {{totalDates > 1 ? "dagen" : "dag"}}</span></div>
          <div v-if="user.type == 1" class="match_percentage">
            <b>{{ job.percentage }}% match</b>
          </div>
        </div>
      </div>
      <svg-icon icon="wave" class="seperator" />

      <div class="job-notification-banner" v-if="user.type == 2">
        <div class="container-fluid">
          <template v-if="companyContact && companyContact.phone">
            <NotificationBanner notification="warning">
              <b>Even overleggen over deze kandidaat?</b>
              <ul>
                <li>Bel ons op: <a  :href="`tel:+${companyContact.phone}`">{{companyContact.number}}</a></li>
                <li>Contact ons via <a class="" :href="`https://api.whatsapp.com/send?phone=${companyContact.phone}&text=${encodeURIComponent(this.whatsappMessage)}`">Whatsapp</a></li>
                <li>Stuur ons een <router-link
                    :to="{ name: 'contact' }"
                >berichtje</router-link
                ></li>
              </ul>
            </NotificationBanner>
          </template>
          <template v-else>
            <NotificationBanner notification="warning">
              <b>Even overleggen over deze kandidaat?</b>
              <ul>
                <li>Bel ons op: <a href="tel:+31850481976">085 048 1976</a></li>
                <li>Contact ons via <a class="" :href="`https://api.whatsapp.com/send?phone=31850481976&text=${encodeURIComponent(this.whatsappMessage)}`">Whatsapp</a></li>
                <li>Stuur ons een <router-link
                    :to="{ name: 'contact' }"
                >berichtje</router-link
                ></li>
              </ul>
            </NotificationBanner>
          </template>
        </div>
      </div>
      <div class="job-messages" v-if="job.interested_comment || job.apply_comment || job.hired_comment">
        <div class="container-fluid no-grid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="blackboard" /> Berichten</div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="message interested" v-if="job.interested_comment">
            <div class="sd-title mini text-align-right">{{ job.company_name }}</div>
            <div class="sd-notif warning apply" >
              <div class="small text-left br">{{ job.interested_comment }}</div>
            </div>
          </div>
          <div class="message apply" v-if="job.apply_comment">
            <div class="sd-title mini text-align-right">{{ job.applicant_firstname }} {{ job.applicant_lastname }}</div>
            <div class="sd-notif warning apply" >
              <div class="small text-left br">{{ job.apply_comment }}</div>
            </div>
          </div>
          <div class="message hired" v-if="job.hired_comment">
            <div class="sd-title mini text-align-right">{{ job.company_name }}</div>
            <div class="sd-notif warning apply" >
              <div class="small text-left br">{{ job.hired_comment }}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="calendar" class="job-availability">
        <div class="container-fluid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="blackboard" /> Vacature</div>
          </div>
          <div class="availablity-specs">
            <template v-if="job.city">
              <strong>Locatie</strong>
              <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
              <span v-else>{{ job.company_name }} ({{ job.city }})</span>
            </template>
            <template v-if="job.sub_branch == 1">
              <strong>Groep</strong> <span>groep {{ formattedAudience() }}</span>
            </template>
            <template v-if="job.sub_branch == 2">
              <strong>Vak en klas(sen)</strong> <span>{{ job.subject }} - {{ formattedAudience() }} klas</span>
            </template>
            <strong>Start-/einddatum</strong> <span>{{ dateFlip(firstDate()) }}{{ totalDates > 1 ? ("/" + dateFlip(lastDate())) : "" }}</span>
            <template v-if="job.sub_branch != 2 && job.duration_type == 0">
              <strong>Totaal aantal dagen</strong> <span>{{totalDates}} {{totalDates > 1 ? "dagen" : "dag"}}</span>
            </template>
            <template v-if="user.type == 1 && (this.action != 'view' && this.action != 'closed') && job.sub_branch != 2 && job.duration_type == 0"><strong>Jouw beschikbare dagen</strong> <span>{{ this.totalMatchedDays }}</span></template>
            <strong v-if="job.sub_branch == 2 && this.job.periods" >Aantal lesuur per week</strong>
            <span v-if="this.job.periods && job.sub_branch == 2">{{ this.job.periods }} lesuur (+ opslagfactor)</span>
            <strong v-if="job.sub_branch == 2 && this.datesWithTime || job.sub_branch == 1 && job.duration_type == 1 && this.datesWithTime">Dagen</strong> <span
              v-if="this.datesWithTime && job.sub_branch == 2 || job.sub_branch == 1 && job.duration_type == 1 && this.datesWithTime">{{ getWorkingDays() }}</span>
          </div>

          <template v-if="subBranch !== '2' && (this.action === 'closed' || this.action === 'view' && hiredDates.length > 0) && job.duration_type == 0">
            <closed-job-dates-overview
                :allDates="allDates"
                :hiredDates="hiredDates"
                :subBranch="job.sub_branch"
            />
          </template>
          <template v-else-if="subBranch !== '2' && job.duration_type == 0">
            <job-dates-overview
                :all-dates="datesWithTime"
                :unmatched-reasons="unmatched_reasons"
                :subBranch="job.sub_branch"
            />
          </template>
        </div>
      </div>
      <div class="job-specs">
        <div class="container-fluid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="suitcase" /> Informatie</div>
          </div>
          <div class="spec-container">
            <div v-if="subBranch == 1" class="branch-school subbranch-primary">
              <div class="spec group">
                <strong>Groep(en)</strong>
                <p class="mb-0">{{ formattedAudience() }}</p>
              </div>
              <div class="spec group-size">
                <strong>Groepsgrootte</strong>
                <p class="mb-0">{{ job.group ? job.group : "-" }}</p>
              </div>
              <div class="spec education-type">
                <strong>Type onderwijs</strong>
                <p class="mb-0">{{ job.education_experience ? job.education_experience : "-" }}</p>
              </div>
              <div class="spec education-type">
                <strong>Denominatie</strong>
                <p class="mb-0">{{ job.denomination }}</p>
              </div>
            </div>
            <div v-if="subBranch == 2" class="branch-school subbranch-secondary">
              <div class="spec group">
                <strong>Klas(sen)</strong>
                <p class="mb-0">{{ formattedAudience() }}</p>
              </div>
              <div class="spec education-type">
                <strong>Type onderwijs</strong>
                <p class="mb-0">{{ formattedGroup() }}</p>
              </div>
              <div class="spec subject">
                <strong>Vak</strong>
                <p class="mb-0">{{ job.subject ? job.subject : "-" }}</p>
              </div>
              <div class="spec qualification">
                <strong>Kwalificatie</strong>
                <p class="mb-0">{{ job.qualification }}</p>
              </div>
            </div>

            <div class="spec description" v-if="job.description">
              <strong>Omschrijving</strong>
              <p class="mb-0">{{ job.description }}</p>
            </div>
            <div class="spec about" v-if="user.type == 1">
              <strong v-if="branch == 2">Over de KDV/BSO</strong>
              <strong v-else>Over de school</strong>
              <p class="mb-0">{{ job.company_about }}</p>
            </div>
            <div class="spec address" v-if="user.type == 1">
              <strong>Adres</strong>
              <p class="address-line">{{ job.name_location }}</p>
              <p class="address-line">{{ job.street }} {{ job.street_number }}{{ job.house_addition }}</p>
              <p class="mb-0">{{ job.postal_code }} {{ job.city }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="job-match" v-if="user.type == 1 && subBranch != '2'">
        <div class="container-fluid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="heart" /> Match</div>
          </div>
          <div class="sd-match" v-if="Object.keys(unmatched_reasons).length > 0">
            <div class="match_info">
              <p>{{ job.percentage }}% match</p>
              <div class="info_content">
                <strong>De volgende punten matchen niet:</strong>
                <ul>
                  <li v-for="(item, i) in unmatched_reasons" v-bind:key="i" class="">
                    <span v-if="i === 'dates' && user.type == 1">Sommige datums matchen niet je beschikbaarheid</span>
                    <span v-else-if="i === 'dates' && user.type == 2">Sommige gevraagde datums matchen niet de beschikbaarheid van deze kandidaat</span>
                    <span v-else>{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="alert_pie">
              <svg-icon icon="pie_chart_75" class="pie-icon"/>
              <p>{{ job.percentage }}%</p>
            </div>
          </div>
          <div class="sd-match" v-else-if="job.percentage !== 0">
            <div class="match_info">
              <p>{{ job.percentage }}% match</p>
              <div class="info_content">
                <strong>Dit is de perfecte match!</strong>
              </div>
            </div>
            <div class="alert_pie" :class="Object.keys(unmatched_reasons).length > 0 ? '' : 'full-marks'">
              <svg-icon icon="pie_chart_100" class="pie-icon"/>
              <p>{{ job.percentage }}%</p>
            </div>
          </div>
          <div class="sd-match" v-else>
            <div class="match_info">
              <p>{{ job.percentage }}% match</p>
              <div class="info_content">
                <strong>Deze match klopt niet<br/> neem alsjeblieft contact met ons op!</strong>
              </div>
            </div>
            <div class="alert_pie">
              <svg-icon icon="pie_chart_100" class="pie-icon"/>
              <p>{{ job.percentage }}%</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <NotificationContainer /> -->
      <!-- If job is closed and user is school -->
      <div v-if="user.type == 2 && action == 'closed'" class="closed-job job-applicant">
        <div class="container-fluid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="heart" /> Sollicitant</div>
          </div>
          <div class="sd-card">
            <div class="avatar rounded-circle position-relative overflow-hidden">
              <span
                v-if="job.applicant_avatar"
                class="d-block image_background"
                :style="this.ImageBackground(job.applicant_avatar)"
              ></span>
              <svg-icon v-else icon="person_male" />
            </div>
            <div class="details">
              <div class="title">
                <strong>{{ job.applicant_firstname ? job.applicant_firstname: "-" }}</strong>
              </div>
              <div class="text ellipsis">{{ job.email }}</div>
              <div class="text ellipsis">{{ job.mobile }}</div>
              <div class="achievements_container">
                <achievements :achievements="job.applicant_achievements" size="small"></achievements>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Als de user school is -->
      <div v-if="job && user.type == 2 && action != 'closed'" class="job-company-button-container">
        <div
          class="container-fluid"
          v-bind:class="[fixed_footer ? 'pb-4 mb-5' : 'pb-1 mb-2']"
        >
          <div>
            <!-- View recommendations -->
            <router-link
              v-if="applicants && applicants.length"
              :to="{ name: 'job-applicants', params: { id: parseInt(job.id) } }"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
              >Bekijk sollicitaties</router-link
            >
            <router-link
              v-if="matches && matches.length"
              :to="{ name: 'job-matches', params: { id: parseInt(job.id) } }"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
              >Bekijk matches</router-link
            >
            <a class="btn btn-light btn-block" @click="editJob" role="button"
              >Bewerken</a
            >
            <a class="btn btn-light btn-block" @click="deleteJob" role="button"
              >Verwijder</a
            >
          </div>
        </div>
      </div>
      <div v-if="fixed_footer" class="job-apply" :class="action == 'applied' ? '' : 'fixed-btn'">
        <div class="container-fluid">
          <div class="">
            <a
              v-if="action == 'apply' || action == 'interested'"
              class="btn btn-warning btn-block"
              role="button"
              @click="onApply"
            >Solliciteer</a
            >
            <a
              v-if="action == 'accept'"
              class="btn btn-warning btn-block"
              role="button"
              @click="onAccept"
            >Accepteer de baan!</a
            >
            <router-link
              v-if="action == 'applied'"
              :to="{ name: 'applicant-dashboard' }"
              class="btn btn-warning btn-block m-2"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Naar je dashboard</router-link
            >
            <a v-if="action == 'applied'" class="btn btn-light btn-block m-2" @click="revertApplication" role="button">
              Sollicitatie intrekken
            </a>
          </div>
        </div>
      </div>
    </div>
    <router-link
      v-if="prev_id"
      id="arrow-back"
      :to="{
        name: 'job',
        params: { id: prev_id, action: action, job_ids: job_ids }
      }"
      class="btn btn-arrow btn-warning position-fixed rounded-circle"
      role="button"
      v-ripple="'rgba(255, 255, 255, 0.35)'"
      hidden
    >
      <span class="icon-wrapper absolute-center">
        <i class="material-icons-round">arrow_back</i>
      </span>
    </router-link>
    <router-link
      v-if="next_id"
      id="arrow-forward"
      :to="{
        name: 'job',
        params: { id: next_id, action: action, job_ids: job_ids }
      }"
      class="btn btn-arrow btn-warning position-fixed rounded-circle"
      role="button"
      v-ripple="'rgba(255, 255, 255, 0.35)'"
      hidden
    >
      <span class="icon-wrapper absolute-center">
        <i class="material-icons-round">arrow_forward</i>
      </span>
    </router-link>
    <!-- Congratulations! Your application has been sent.
    You will be notified when there is a match!-->
    <Notification
      v-if="fullscreen_notif == 'applied'"
      text="<p>Goed bezig, je sollicitatie is verstuurd!</p>"
      :link="{ name: 'applicant-dashboard' }"
      button="Terug naar het dashboard"
      button_style="btn-light"
    />
    <!-- You have accepted the job!
    You will receive a message quickly as to whether
    the employer has the match confirmed so you can get started!-->
    <Notification
      v-if="fullscreen_notif == 'accepted'"
      text="<p>Je hebt de baan geaccepteerd!</p>
            <p>Je ontvangt snel een bericht of de werkgever de match heeft bevestigd zodat je aan de slag kan!</p>"
      :link="{ name: 'applicant-dashboard' }"
      button="Naar mijn dashboard"
    />
    <Notification
      v-if="fullscreen_notif == 'salary'"
      v-model="fullscreen_notif"
      :link="{ name: 'salary-details' }"
      text="<p>Oeps, je hebt nog geen verdiensten ingevuld!</p>"
      button="Verdiensten toevoegen"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="
        fullscreen_notif == 'passport' &&
          (user.is_keesing == 0 && user.id_image)
      "
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-dashboard' }"
      text="<p>Zo, jij bent snel! Momenteel wordt jouw paspoort nog gecontroleerd. Dit zal niet lang duren, probeer het dus later nog eens.</p>"
      button="Naar je dashboard"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="
        fullscreen_notif == 'passport' &&
          (user.is_keesing == 0 && !user.id_image)
      "
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-step_1', params: { action: 'save' } }"
      text="<p>O jee! We hebben nog geen paspoort of ID-bewijs van je ontvangen.</p>"
      button="Doorgaan met uploaden"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="fullscreen_notif == 'passport' && user.is_keesing == 3"
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-step_1', params: { action: 'save' } }"
      text="<p>Je identificatiebewijs kan niet goed gelezen worden. Probeer het nogmaals.</p>"
      button="Doorgaan met uploaden"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="fullscreen_notif == 'diploma' && user.branch == 2"
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-diplomas' }"
      text="<p>Oeps! We moeten eerst jouw diploma('s) goedkeuren voordat je kan solliciteren. Heb je nog geen diploma geüpload? Doe dat dan zo snel mogelijk.</p>"
      button="Upload een diploma"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="fullscreen_notif == 'unqualified' && user.branch == 2"
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-dashboard' }"
      text="<p>Je bent helaas niet bevoegd voor deze vacature. We bepalen je bevoegdheid op basis van je diploma('s). Denk je dat dit niet klopt? Neem dan contact met ons op.</p>"
      button="Naar je dashboard"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="fullscreen_notif == 'vog' && (user.vog_status == 'pending')"
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-dashboard' }"
      text="<p>Zo, jij bent snel! Momenteel wordt jouw VOG Certificaat nog gecontroleerd. Dit zal niet lang duren, probeer het dus later nog eens.</p>"
      button="Naar je dashboard"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="fullscreen_notif == 'vog' && (user.vog_status == 'no_file')"
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-step_1', params: { action: 'save' } }"
      text="<p>Ojee! Je VOG ontbreekt nog.</p>"
      button="Upload VOG of vraag een nieuwe aan"
      button_style="btn-light"
      :show="true"
    />
    <Notification
      v-if="fullscreen_notif == 'vog' && user.vog_status == 'rejected'"
      v-model="fullscreen_notif"
      :link="{ name: 'applicant-step_1', params: { action: 'save' } }"
      text="<p>Je VOG Certificaat kan niet goed gelezen worden. Upload snel een nieuwe.</p>"
      button="Doorgaan met uploaden"
      button_style="btn-light"
      :show="true"
    />
    <div v-if="fullscreen_notif == 'comment'" class="fullscreen-notif match position-fixed">
      <button
        type="button"
        class="close position-fixed"
        aria-label="Close"
        v-on:click="fullscreen_notif = null"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="pb-1">
            <div>
              <template v-if="subBranch !== '2'">
                <div class="sd-title mini mb-20px">
                  <div class="title-text"><svg-icon icon="heart" /> Is er een match?</div>
                </div>
                <div class="sd-match" v-if="Object.keys(unmatched_reasons).length > 0" style="margin-bottom: 20px;">
                  <div class="match_info">
                    <div class="info_content">
                      <ul><li class="sd-title mini">Je hebt een {{ job.percentage }}% match</li></ul>
                      <strong>De volgende punten matchen niet:</strong>
                      <ul>
                        <li v-for="(item, i) in unmatched_reasons" v-bind:key="i" class="">
                          <span v-if="i === 'dates' && user.type == 1">Sommige datums matchen niet je beschikbaarheid</span>
                          <span v-else-if="i === 'dates' && user.type == 2">Sommige gevraagde datums matchen niet de beschikbaarheid van deze kandidaat</span>
                          <span v-else>{{ item }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="alert_pie">
                    <svg-icon icon="pie_chart_75" class="pie-icon"/>
                    <p>{{ job.percentage }}%</p>
                  </div>
                </div>
              </template>
              <div class="form-group text-left">
                <h4 class="sd-title small">Heb je nog vragen of opmerkingen voor {{ job.company_name }}?</h4>
              </div>
              <div class="form-group mb-5">
                <textarea
                  maxlength="160"
                  class="form-control"
                  :placeholder="'Heb je vragen of opmerkingen over deze vacature? \nGeef hier ook aan als je alleen op aangepaste tijden beschikbaar bent \n\n(Max. 160 tekens)'"
                  rows="4"
                  spellcheck="false"
                  v-model="comment"
                ></textarea>
<!--                <span class="extra-info mt-2">-->
<!--                  <svg-icon icon="information" />-->
<!--                  Heb je vragen of opmerkingen over deze vacature? Geef hier ook aan als je alleen op aangepaste tijden beschikbaar bent. (Max. 160 tekens)-->
<!--                </span>-->
              </div>
              <a
                v-if="action == 'apply' || action == 'interested'"
                class="btn btn-warning btn-block"
                role="button"
                @click="onSubmitApplication"
                >Solliciteer</a
              >
              <a
                v-if="action == 'accept'"
                class="btn btn-warning btn-block"
                role="button"
                @click="onSubmitAccept"
                >Doorgaan</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";
import JobDatesOverview from "@/components/JobDatesOverview";
import ClosedJobDatesOverview from "@/components/ClosedJobDatesOverview.vue";

export default {
  data: function() {
    return {
      branch: localStorage.getItem("branch"),
      subBranch: localStorage.getItem("subBranch"),
      user: null,
      job: null,
      dates: null,
      allDates: null,
      hiredDates: null,
      datesWithTime: null,
      applicant: null,
      applicants: null,
      matches: null,
      fixed_footer: null,
      fullscreen_notif: null,
      comment: "",
      keesing: "",
      whatsappMessage: "",
      center: null,
      unmatched_reasons: {},
      maxVisibleDates: 4,
      totalDates: null,
      hiddenDates: null,
      showAllDates: false,
      totalMatchedDays: null,
      companyContact: null,
    };
  },
  props: ["id", "matched_job_id", "matched_applicant_id", "action", "job_ids"],
  async created() {},
  async mounted() {
    await this.fetchData();
    this.calculateDates();
    let notification;

    if(this.action == 'declined') {
      notification = {
        type: "danger",
        message: "De school heeft jouw sollicitatie afgewezen.",
        noTryAgain: true
      };
      this.$store.dispatch("notification/replace", notification, {root: true});
    }

    if(this.action == 'applied' && this.job.sub_branch == '2') {
      notification = {
        type: "success",
        message: "We nemen contact met je op als de school interesse heeft in je profiel!",
        noTryAgain: true
      };
      this.$store.dispatch("notification/replace", notification, {root: true});
    }

    else if(this.action == 'applied') {
      notification = {
        type: "success",
        message: "Je hebt op deze vacature gesolliciteerd :)",
        noTryAgain: true
      };
      this.$store.dispatch("notification/replace", notification, {root: true});
    }

    if(this.action == 'interested') {
      notification = {
        type: "success",
        message: "Deze organisatie heeft interesse in jou getoond!",
        noTryAgain: true
      };
      this.$store.dispatch("notification/replace", notification, {root: true});
    }


  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      if(this.user.company_contact)
      {
        this.companyContact = await this.getTokenAPIList(
            "admins/" + parseInt(this.user.company_contact)
        );

        if(this.companyContact.number) {
          let original_number = this.companyContact.number;

          this.companyContact.phone = original_number.replace(/^\d/, "31");
        }
      }

      var ID = parseInt(this.id);
      this.job = await this.getTokenAPIList("job/" + ID);

      this.subBranch = this.job.sub_branch;
      if(this.job.unmatched_reasons) {
        this.unmatched_reasons = JSON.parse(this.job.unmatched_reasons);
      }
      const datesWithTime = JSON.parse(JSON.parse(this.job.working_dates_with_times));
      if (datesWithTime) {
        this.datesWithTime = datesWithTime;
      }
      const dates = JSON.parse(this.job.working_dates);
      if (dates) {
        this.dates = dates;
      }

      if (this.job.hired_dates) {
         const hiredDates = JSON.parse(this.job.hired_dates);
         this.hiredDates = Object.keys(hiredDates);
      } else {
        this.hiredDates = [];
      }

      if (this.job.all_working_dates) {
        this.allDates  = JSON.parse(this.job.all_working_dates);
      }
      
      this.center = {
        lat: parseFloat(this.job.lat),
        lng: parseFloat(this.job.lng)
      };
      // console.log(this.job);
      // if company
      if (this.user.type == 2 && this.action != "closed") {
        this.applicants = await this.getTokenAPIList("applicants/" + ID);
        this.matches = await this.getTokenAPIList("job/" + ID + "/matches");
      }

      if(this.job.time_add_on)
      {
        this.job.time_add_on = parseFloat(this.job.time_add_on);
      }

      // this.profession = await this.getAPIList(
      //   "professions",
      //   this.job.profession_id
      // );
      // this.degree = await this.getAPIList("degrees", this.job.degree_id);

      this.whatsappMessage = "Ik heb een vraag over de vacature: " + this.job.title + " (vacaturenummer: " + this.job.id + ")."

      // check for footer
      this.fixed_footer = ["apply", "applied", "accept", "interested"].includes(this.action);
      this.$store.state.loading = false;
    },
    calculateDates() {
      this.totalDates = Object.keys(JSON.parse(this.dates)).length;
      this.hiddenDates = this.totalDates - this.maxVisibleDates;

      if(typeof this.unmatched_reasons.dates !== 'undefined' && Array.isArray(this.unmatched_reasons.dates))
        this.totalMatchedDays = this.totalDates - this.unmatched_reasons.dates.length;
      else
        this.totalMatchedDays = this.totalDates;
    },
    async onApply() {
      this.$store.dispatch("notification/replace", {}, {
        root: true
      });

      if (this.user.salary_id <= 0) {
        this.fullscreen_notif = "salary";
      } else if (!this.elContains([1, 2, 9], this.user.is_keesing) && this.job.sub_branch === '1') {
        this.fullscreen_notif = "passport";
      } else if (this.user.vog_status != 'approved' && this.user.vog_status != 'exported' && this.user.vog_status != 'expired' && this.job.sub_branch === '1') {
        this.fullscreen_notif = "vog";
      } else if (this.user.workfield > 2 && this.user.branch == 2 && this.job.sub_branch === '1') {
        this.fullscreen_notif = "diploma";
      } else if (this.user.branch == 2 && ((this.user.workfield == 1 && this.job.workfield == 68) || (this.user.workfield == 2 && this.job.workfield == 67) || (this.user.workfield == 2 && this.job.workfield == 73))) {
        this.fullscreen_notif = "unqualified";
      } else {
        this.fullscreen_notif = "comment";
      }
    },
    async onSubmitApplication() {
      this.$store.state.loading = true;
      window.scrollTo(0, 0);
      try {
        await this.sendApplication(
          this.job.id,
          this.comment,
          this.job.percentage,
          this.job.unmatched_reasons,
          this.job.interested_comment,
        );
        this.fullscreen_notif = "applied";
      } catch (e) {
        this.fullscreen_notif = null;
      }
    },
    async onAccept() {
      this.fullscreen_notif = "comment";
    },
    async onSubmitAccept() {
      this.$store.state.loading = true;
      window.scrollTo(0, 0);
      try {
        await this.acceptJob(this.matched_applicant_id, this.comment);
        this.fullscreen_notif = "accepted";
      } catch (e) {
        this.fullscreen_notif = null;
      }
    },
    async editJob() {
      localStorage.setItem("job", JSON.stringify(this.job));
      this.$router.replace({ name: "job_step-1" });
    },
    async deleteJob() {
      const ID = parseInt(this.id);
      await this.deleteRecord("/job/" + ID);
      // continue only if resolve()
      this.$router.replace({ name: "company-dashboard" });
    },
    async revertApplication() {
      const applicantId = parseInt(this.user.id);
      const jobId = parseInt(this.id);
      await this.withdrawApplication("/withdraw/" + applicantId + '/' + jobId);
      // continue only if resolve()
      this.$router.replace({ name: "company-dashboard" });
    },
    elContains(str, target) {
      return str.includes(target);
    },
    dateFlip(date) {
      return date.split("-").reverse().join("-");
    },
    firstDate() {
      return Object.keys(JSON.parse(this.dates))[0];
    },
    lastDate() {
      let lastIndex = Object.keys(JSON.parse(this.dates)).length - 1;
      return Object.keys(JSON.parse(this.dates))[lastIndex];
    },
    formattedAudience() {
      if(this.job.audience != null) {
        try {
          return JSON.parse(this.job.audience).join(', ');
        } catch(error) {
          console.log('job.audience is not JSON');
          return this.job.audience;
        }
      }
      else
        return '';
    },
    formattedGroup() {
      if(this.job.group != null) {
        try {
          return JSON.parse(this.job.group).join(', ');
        } catch(error) {
          console.log('job.group is not JSON');
          return this.job.group;
        }
      }
      else
        return '';
    },
    getWorkingDays() {
      if (!this.datesWithTime) return '';
      if (this.job.dates_pending) return 'In overleg / nog onbekend';

      const days = new Set();
      const weekDays = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag'];

      Object.keys(this.datesWithTime).forEach(date => {
        const dayIndex = new Date(date).getDay() - 1;
        if (dayIndex >= 0 && dayIndex < 5) {
          days.add(weekDays[dayIndex]);
        }
      });

      return weekDays.filter(day => days.has(day)).join(', ');
    }
  },
  computed: {
    prev_id: function() {
      if (this.job_ids) {
        var i = this.job_ids.indexOf(parseInt(this.id));
        i = i - 1;
        return this.job_ids[i];
      }
      return "";
    },
    next_id: function() {
      if (this.job_ids) {
        var i = this.job_ids.indexOf(parseInt(this.id));
        i = i + 1;
        return this.job_ids[i];
      }
      return "";
    }
  },
  components: {
    ClosedJobDatesOverview,
    JobDatesOverview,
    Achievements
  }
};
</script>

<style scoped>
.sd-job .sd-card {
  display: flex;
  align-items: center;
  padding: 30px;
  border-radius: 10px;
  background-color: #FFF;
  border: 2px solid #FFCD00;
}

/deep/.sd-job .closed-job .sd-card .svg-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/.sd-job .closed-job .sd-card .svg-container svg {
  width: 60px;
  height: 60px;
}

.sd-job .job-header {
  display: flex;
  align-items: center;
  padding-top: 40px;
}

.sd-job .job-header .avatar .avatar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.sd-job .job-header .avatar .avatar-icon /deep/.svg-container svg {
  height: 60px;
  width: 60px;
  color: #FFF;
}

.sd-job .job-header .spec-container > div:not(:last-child) {
  line-height: 1;
  margin-bottom: 15px;
}

.sd-job .job-header .spec-container .match_percentage {
  display: inline-block;
  background-color: #FFCD00;
  border-radius: 10px;
  padding: 2px 10px;
}

.sd-job .job-header .spec-container .duration_type {
  border-radius: 10px;
  padding: 3px 15px;
  margin-left: 5px;
}

.sd-job .job-header .spec-container .duration_type.recent {
  height: 25px;
  background-color: #F6F6F6;
}

.sd-job .job-header .spec-container .duration_type.recent_yellow {
  height: 25px;
  background-color: #FFF9E2;
}

.sd-job .seperator {
  display: block;
  width: 100%;
  color: #F6F6F6;
}

.sd-job .job-availability {
  background-color: #F6F6F6;
}

.sd-job .job-availability .availablity-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 15px;
  background-color: #FFF;
  border-radius: 10px;
  padding: 30px;
  font-size: 12px;
  line-height: 1;
}

/deep/.sd-job .job-availability .sd-date-overview {
  background-color: #FFF;
  border-radius: 10px;
  padding: 30px 30px 15px;
  margin-top: 15px;
}

.sd-job .job-specs {
  padding: 40px 0;
  background-color: #F6F6F6;
}

.sd-job .job-specs .spec-container {
  border-radius: 10px;
  padding: 30px;
  background-color: #FFF;
}

.sd-job .job-specs .spec-container .branch-school,
.sd-job .job-specs .spec-container .branch-opvang {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 30px;
  margin-bottom: 30px;
}

.sd-job .job-specs .spec {
  line-height: 1;
}

.sd-job .job-specs .spec.group,
.sd-job .job-specs .spec.education-type {
  grid-column: span 2;
}

.sd-job .job-specs .spec strong {
  display: block;
  margin-bottom: 15px;
}

.sd-job .job-specs .description,
.sd-job .job-specs .about {
  margin-bottom: 30px;
}

.sd-job .job-specs .address .address-line {
  margin-bottom: 15px;
}

.sd-job .job-notification-banner {
  padding-top: 15px;
  background-color: #F6F6F6;
}

.sd-job .job-match {
  background-color: #F6F6F6;
  padding-bottom: 40px;
}

.sd-job .job-applicant {
  padding: 0 0 40px;
  background-color: #F6F6F6;
}

.sd-job .job-company-button-container {
  padding: 40px 0;
}

.pie-icon {
  width: 60px;
  height: 60px;
}

/deep/.pie-icon .filled-chart {
  fill: #FFCD00;
}

/deep/.pie-icon .empty-chart {
  fill: #FFF;
}

.alert_pie {
  fill: #FFF;
}

.sd-match {
  display: flex;
  align-items: center;
  position: relative;
  background-color: #FFF;
  padding: 30px;
  border-radius: 10px;
}

.sd-match .match_info p {
  font-weight: 200;
}

.sd-match .info_content {
  font-size: 12px;
  margin-right: 60px;
}

.sd-match .info_content ul {
  list-style: none;
  padding-left: 0;
}

.sd-match .info_content ul li {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 20px;
}

.sd-match .info_content ul li::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  height: 5px;
  width: 5px;
  border-radius: 100%;
  background-color: #FFCD00;
}

.alert_pie {
  position: absolute;
  right: 30px;
}

.alert_pie p {
  margin: 0;
  text-align: center;
  position: absolute;
  top: 35px;
  left: 15px;
  color: #FFF;
  font-size: 12px;
}

.alert_pie.full-marks {
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert_pie.full-marks p {
  top: unset;
  left: unset;
}

.sd-job .job-messages {
  background-color: #F6F6F6;
  padding: 40px 0 0;
}

.sd-job .job-messages .container-fluid:not(.no-grid) {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.sd-job .job-messages .container-fluid > .sd-title {
  grid-row: -1;
  grid-column: span 2;
}

.sd-job .job-messages .container-fluid .message .sd-title {
  margin-left: 15px;
}

.sd-job .job-messages .container-fluid .message.interested {
  grid-row: 1;
  grid-column: 1;
}

.sd-job .job-messages .container-fluid .message.apply {
  grid-row: 2;
  grid-column: 2;
}

.sd-job .job-messages .container-fluid .message.hired {
  grid-row: 3;
  grid-column: 1;
}

.sd-job .job-apply {
  background-color: #F6F6F6;
  padding: 40px 0;
}

.btn-light {
  background-color: #f5f4f4;
}
.company-avatar {
  height: 200px;
}
span.date:after {
  content: ",";
  margin-right: 7px;
}
span.date:last-child:after {
  display: none;
}
/* .fullscreen-notif.bg-light {
  background: red;
} */

span.question-mark {
  width: 28px;
  height: 28px;
  background: #FFCD00;
  display: inline-block;
  border-radius: 100%;
  font: 16px/28px "Real Head Pro";
  font-weight: normal;
  margin-left: 10px;
}

#profile #calendar .clearfix {
  height: auto;
}
#profile #calendar label.text-yellow {
  margin: 0;
  float: left;
}
#profile #calendar p.dates {
  float: left;
  max-width: calc(100% - 65px);
  margin-left: 10px;
  margin-bottom: 0;
}
#profile #calendar .clearfix strong {
  cursor: inherit;
}
</style>
